import React from 'react';
import PropTypes from 'prop-types';
import clsx from '@strava/ui/clsx';
import { useStravaBranch } from '@strava/container-context';
import { getProfileVisibility } from '../../helpers/getProfileVisibility';
import { useLoggedOutAthletePageContext } from '../../state/LoggedOutAthletePageContext';

import appStore1x from './assets/badge-app-store.png';
import appStore2x from './assets/badge-app-store@2x.png';
import playStore1x from './assets/badge-play-store.png';
import playStore2x from './assets/badge-play-store@2x.png';

import styles from './GetTheAppCTA.module.scss';

const GetTheAppCTA = ({ className }) => {
  const { t, track, state } = useLoggedOutAthletePageContext();
  const { athleteData } = state;
  const { athlete } = athleteData;
  const branch = useStravaBranch();
  const { appLink } = branch;

  const handleTrack = (type) => {
    track({
      action: 'click',
      element: 'get_app',
      properties: {
        profile_visibility: getProfileVisibility(athlete),
        cta_copy: `${type}_app_store`,
        url: appLink
      }
    });
  };

  return (
    <div className={clsx(styles.getTheAppCTA, className)}>
      <h3>{t('get_the_app_cta')}</h3>
      <div className={styles.appLinks}>
        <a href={appLink} onClick={() => handleTrack('apple')}>
          <img
            alt={t('download_on_the_app_store')}
            srcSet={`${appStore1x} 1x, ${appStore2x} 2x`}
            src={appStore1x}
          />
        </a>
        <a href={appLink} onClick={() => handleTrack('google')}>
          <img
            alt={t('get_it_on_google_play')}
            srcSet={`${playStore1x} 1x, ${playStore2x} 2x`}
            src={playStore1x}
          />
        </a>
      </div>
    </div>
  );
};

GetTheAppCTA.defaultProps = {
  className: null
};

GetTheAppCTA.propTypes = {
  className: PropTypes.string
};

export default GetTheAppCTA;
